
$(document).ready(function(){


    $("body").on('DOMSubtreeModified', ".site-header__search-container", function() {
        if ($(".site-header__search-container").hasClass("is-active"))
        {
            $("body").css({'overflow' : 'hidden'});
            $(".slick-track, .slick-slide").css({'width' : '100%'});
            $(".search-overlay").show();

 
       
  
        
        } else {
            $("body").css({'overflow' : ''});
            $(".slick-track").css({'width' : ''});
            $(".search-overlay").hide();
        }
    });   
    


    $(document).on('change', '#PredictiveResults', function() {
        $(".search-overlay").css({'display' : 'none'});
    
       
    }); 

    $('.drawer__close-button.js-drawer-close').click(function() {
        location.reload();
    });


        /* close the mobile nav */
        $( ".mobile-nav__sublist.collapsible-content" ).each(function( index ) 
        {
            $(this).removeClass("is-open");
            $(this).css({"height" : "0"});
            $("#NavDrawer .mobile-nav__toggle button.collapsible-trigger").removeClass("is-open");
            $("#NavDrawer .mobile-nav__toggle .collapsible-trigger").attr("aria-expanded","false");
        });

    



                $("#NavDrawer button.disclosure__toggle").off("click").on("click", function () {
                    $("#LangList").toggle();
                });


        /* testing for search results */
        /* first hide search */

                $(".template-search .collection-filter").hide();
                $(".template-search .boost-pfs-filter-products").hide();
             
                   



});




$(window).load(function() {
    if ( $(".template-search .boost-pfs-filter-message").length)
    {
        console.log("search results none");
        $("body title").empty();
        $(".template-search .search-no-result .forcustom").show();

    } else 
    {



       console.log("search results some");
        
       $(".template-search .collection-filter").show();
       $(".template-search .boost-pfs-filter-products").show();
       $(".template-search .search-no-result .forcustom").hide();


    }
});